import { Link } from "react-router-dom";
import type { NewsItem } from "@/types";

interface NewsCardProps {
  news: NewsItem;
  layout?: "vertical" | "horizontal";
}

export default function NewsCard({ news, layout = "vertical" }: NewsCardProps) {
  if (layout === "horizontal") {
    return (
      <Link
        to={`/detail/${news.id}`}
        className="group flex cursor-pointer gap-3 rounded-lg border border-background-200 bg-background-50 p-2.5 transition-colors hover:border-primary-300"
      >
        <div className="h-20 w-28 flex-none overflow-hidden rounded-md bg-background-200">
          <img
            src={news.cover}
            alt={`《${news.title}》新闻配图`}
            title={`${news.title} 动漫新闻`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="flex min-w-0 flex-1 flex-col justify-between py-0.5">
          <h3 className="line-clamp-2 text-sm font-semibold text-foreground-950 group-hover:text-primary-700">
            {news.title}
          </h3>
          <div className="flex items-center gap-2 text-xs text-foreground-500">
            <span className="text-accent-600">{news.category}</span>
            <span className="h-3 w-px bg-background-300"></span>
            <time>{news.publishTime}</time>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/detail/${news.id}`}
      className="group flex cursor-pointer flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="aspect-[16/10] w-full overflow-hidden bg-background-200">
        <img
          src={news.cover}
          alt={`《${news.title}》新闻配图`}
          title={`${news.title} 动漫新闻`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex flex-1 flex-col p-3.5">
        <span className="mb-1.5 w-fit rounded-full bg-accent-100 px-2 py-0.5 text-[11px] font-medium text-accent-800">
          {news.category}
        </span>
        <h3 className="line-clamp-2 text-sm font-bold text-foreground-950 group-hover:text-primary-700">
          {news.title}
        </h3>
        <p className="mt-1.5 line-clamp-2 flex-1 text-xs leading-relaxed text-foreground-600">
          {news.summary}
        </p>
        <div className="mt-3 flex items-center justify-between text-xs text-foreground-500">
          <time>{news.publishTime}</time>
          <span className="inline-flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {news.views}
          </span>
        </div>
      </div>
    </Link>
  );
}